import { render, staticRenderFns } from "./CreateTaskField.vue?vue&type=template&id=748f4848&scoped=true&"
import script from "./CreateTaskField.vue?vue&type=script&lang=js&"
export * from "./CreateTaskField.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskField.vue?vue&type=style&index=0&id=748f4848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748f4848",
  null
  
)

export default component.exports